import styled from 'styled-components';

import ButtonBar from './Boneyard/ButtonBar/styled/retro';
import { Button } from './Boneyard/ButtonBar/ButtonBar';

import PlainButton from './PlainButton';
import { Button as ButtonLink } from './Button';

// Make ButtonLink and PlainButton styles behave like RetroButton children
export default styled(ButtonBar)`
  display: flex;
  align-items: center;
  ${ButtonLink},
  ${PlainButton} {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 280px;

    ${props => props.theme.query.md} {
      width: auto;
    }
  }

  ${Button} + ${Button} {
    ${props => props.theme.query.sm} {
      display: flex;
      justify-content: center;

      /* Apply spacing when multiple buttons are the same side. Ideally boneyard->ButtonBar should handle this */
      margin-left: ${props => props.theme.spacing(2)};
    }
  }
`;
